module.exports = __webpack_public_path__ + "static/media/bg-img-4.222bdc7a.svg";